import { Component, Input, OnChanges } from '@angular/core';
import { SharedModule } from '../../../@commons/ui-components/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass } from '@angular/common';
import { CultivationItemViewerComponent } from './cultivation-item-viewer/cultivation-item-viewer.component';

@Component({
  selector: 'vw-hierarchy-item',
  imports: [
    SharedModule,
    TranslateModule,
    NgClass,
    CultivationItemViewerComponent,
  ],
  templateUrl: './hierarchy-item.component.html',
  styleUrl: './hierarchy-item.component.scss'
})
export class HierarchyItemComponent implements OnChanges {
  @Input() hierarchy: any;
  actionRequired: boolean = false;

  ngOnChanges() {
    // « Action attendue » : au moins un plant de la hiérarchie est sur une étape manuelle
    // (isBlocking) dont la durée est écoulée. La progression n'étant pas sérialisée sur les
    // plants imbriqués de myGarden, on la calcule depuis la date de début d'étape + durée.
    this.actionRequired =
      (this.hierarchy as any)?.actionRequired === true ||
      this.computeActionRequired(this.hierarchy);
  }

  private computeActionRequired(h: any): boolean {
    return (h?.cultivations ?? []).some((c: any) =>
      (c?.variants ?? []).some((v: any) => {
        const plants = Array.isArray(v?.plants) ? v.plants : v?.plants ? [v.plants] : [];
        return plants.some((p: any) => this.plantNeedsAction(p));
      }),
    );
  }

  private plantNeedsAction(p: any): boolean {
    if (!p?.currentGrowingStep?.isBlocking) return false;
    const start = p.currentGrowingStepStartDate
      ? new Date(p.currentGrowingStepStartDate).getTime()
      : NaN;
    const durationDays = p.currentGrowingStep?.durationDays;
    if (!isFinite(start) || !durationDays) return false;
    const progression = (Date.now() - start) / (durationDays * 86400000);
    return progression >= 1;
  }
}
